module.exports = __webpack_public_path__ + "static/img/add.b3ae6fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/add.png
// module id = t23k
// module chunks = 1